import { MagnifyingGlassPlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Zoomin = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <MagnifyingGlassPlusIcon {...rest} size={Sizes[size]} color={fill} />;
};

Zoomin.displayName = 'Zoomin';
